var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_app_wrapper",class:{
    with_english: _vm.whichLanguage == 'en',
    with_arabic: _vm.whichLanguage == 'ar',
  },attrs:{"id":"app"}},[_c('div',[(!_vm.$route.meta.hideNavbar)?_c('app-navbar'):_vm._e(),_c('transition',{attrs:{"name":"moveUp"}},[_c('router-view')],1),(!_vm.$route.meta.hideNavbar)?_c('app-footer'):_vm._e()],1),_c('AppLoading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }